import React from "react";

export const DiliCheckboxCP = ({
  name,
  checked,
  onChange,
  label,
  containerProps,
  containerClassAppend,
  inputClassAppend,
  labelProps,
  labelClassAppend,
  ...inputProps
}) => {
  return (
    <div
      className={
        "form-group form-check" +
        (containerClassAppend ? ` ${containerClassAppend}` : "")
      }
      {...containerProps}
    >
      <input
        name={name}
        type="checkbox"
        className={
          "form-check-input" + (inputClassAppend ? ` ${inputClassAppend}` : "")
        }
        onChange={onChange}
        checked={checked}
        {...inputProps}
      />
      <label
        className={
          "form-check-label" + +(labelClassAppend ? ` ${labelClassAppend}` : "")
        }
        {...labelProps}
      >
        {label}
      </label>
    </div>
  );
};
